/**
 * Environment configuration for the admin application
 * This file handles Vite environment variables and provides them to the shared package
 */

import { logger, getEnvVar } from '@musedrops/shared';

export const ENV_CONFIG = {
  ENV: (getEnvVar('VITE_ENV') || getEnvVar('ENV') || 'development')
    .toLowerCase()
    .trim(),
  CLOUD_RUN_GEN_SERVICE_URL: getEnvVar('CLOUD_RUN_GEN_SERVICE_URL') || '',
  API_BASE_URL: getEnvVar('API_BASE_URL') || '',
  SUPABASE_URL: getEnvVar('SUPABASE_URL') || '',
  SUPABASE_ANON_KEY: getEnvVar('SUPABASE_ANON_KEY') || '',
};

logger.debug('Environment config loaded', {
  ENV: ENV_CONFIG.ENV,
  CLOUD_RUN_GEN_SERVICE_URL: ENV_CONFIG.CLOUD_RUN_GEN_SERVICE_URL
    ? '✓ Set'
    : '✗ Missing',
  API_BASE_URL: ENV_CONFIG.API_BASE_URL ? '✓ Set' : '✗ Missing',
  SUPABASE_URL: ENV_CONFIG.SUPABASE_URL ? '✓ Set' : '✗ Missing',
  SUPABASE_ANON_KEY: ENV_CONFIG.SUPABASE_ANON_KEY ? '✓ Set' : '✗ Missing',
});

/**
 * Checks if the application is running in the production environment
 *
 * Production is identified by the ENV variable being set to 'production'.
 * This provides a reliable and explicit way to distinguish production from development/local environments.
 *
 * @returns true if running in production, false otherwise
 */
export function isProduction(): boolean {
  return ENV_CONFIG.ENV === 'production';
}

/**
 * Checks if the application is running in a local development environment
 *
 * Local is identified by Supabase URL pointing to localhost or 127.0.0.1
 * This distinguishes local Supabase from hosted dev/prod environments.
 *
 * @returns true if running with local Supabase, false otherwise
 */
export function isLocal(): boolean {
  const url = ENV_CONFIG.SUPABASE_URL.toLowerCase();
  return url.includes('localhost') || url.includes('127.0.0.1');
}
